"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Card_1 = require("@dialogexe/cw-component-card/Card");
const icons_1 = require("@dialogexe/cw-asset-provider/icons");
const moment = require("moment");
require("moment/locale/nn");
require("moment/locale/nb");
const BULLET_POINT = `\u2022`;
const ON_CINEMA_NOW = "På kino nå";
const COMING = "Kommende filmer";
class Events extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCategory: null
        };
        this.translateToNyNorsk = (value) => {
            switch (value) {
                case ON_CINEMA_NOW:
                    return 'På kino no';
                case COMING:
                    return 'Komande filmar';
                default:
                    return value;
            }
        };
        const preferredLanguage = props.preferredLanguage ? props.preferredLanguage : 'nb';
        moment.locale(preferredLanguage);
    }
    render() {
        const { title, imagePlaceholder } = this.props;
        const cards = this.getFilteredCards();
        if (cards.length === 0) {
            return (React.createElement("div", null));
        }
        return (React.createElement("div", { className: "Events" },
            React.createElement("h1", { className: "title" }, title),
            this.renderFilter(),
            React.createElement("div", { className: "row is-spaced" }, cards.map((card, index) => (React.createElement("div", { key: index, className: "column is-lg-3 is-md-4 is-xs-6 card-item" },
                React.createElement(Card_1.Card, { image: card.image || imagePlaceholder, title: card.title, subtitle: this.formatSubtitle(card.subtitle, card.type), link: card.link, alternate: true })))))));
    }
    renderFilter() {
        const selectedCategory = this.resolveSelectedCategory();
        let categories = this.getDistinctCategories();
        const { preferredLanguage } = this.props;
        if (categories.length === 1) {
            return;
        }
        return (React.createElement("nav", { className: "filter" },
            React.createElement("div", { className: "tabs is-hidden-mobile" }, categories.map((category, i) => (React.createElement("a", { key: i, href: "#", className: `tab ${category === selectedCategory ? 'is-active' : ''}`, onClick: (e) => { e.preventDefault(); this.onCategorySelect.bind(this)(category); } }, preferredLanguage === 'nn' ? this.translateToNyNorsk(category) : category)))),
            React.createElement("div", { className: "is-hidden-tablet" },
                React.createElement("div", { className: "input" },
                    React.createElement("select", { className: "", onChange: (e) => {
                            e.target.value === '' ?
                                this.setState({ selectedCategory: null }) :
                                this.setState(({ selectedCategory: e.target.value }));
                        } }, categories.map((category, i) => (React.createElement("option", { value: category, key: i }, preferredLanguage === 'nn' ? this.translateToNyNorsk(category) : category)))),
                    React.createElement("i", { className: "" },
                        React.createElement("img", { src: icons_1.arrowheadDownIcon, alt: "" }))))));
    }
    onCategorySelect(category) {
        this.setState({
            selectedCategory: category
        });
    }
    formatSubtitle(subtitle, type) {
        if (!moment(subtitle).isValid()) {
            return subtitle;
        }
        if (type === 'movie_coming') {
            return 'Premiere ' + moment(subtitle).format('ll');
        }
        if (type === 'movie') {
            return '';
        }
        const day = this.capitalizeFirstLetter(moment(subtitle).format("dddd"));
        return `${day} ${moment(subtitle).format("DD. MMMM")} ${BULLET_POINT} ${moment(subtitle).format("HH:mm")}`;
    }
    capitalizeFirstLetter(text) {
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }
    getFilteredCards() {
        const { cards } = this.props;
        const selectedCategory = this.resolveSelectedCategory();
        const filterBySelectedCategory = cards.filter(card => (selectedCategory === null || card.category === selectedCategory));
        const groupedByCategory = this.getUniqueCards(filterBySelectedCategory);
        return groupedByCategory.sort((c1, c2) => (moment(c1.date).unix() - moment(c2.date).unix()));
    }
    resolveSelectedCategory() {
        const { selectedCategory } = this.state;
        const categories = this.getDistinctCategories(true);
        if (selectedCategory !== null) {
            return this.state.selectedCategory;
        }
        let preselectMoviesCat = '';
        if (typeof categories['movie'] !== 'undefined') {
            preselectMoviesCat = categories['movie'];
        }
        else if (typeof categories['movie_coming'] !== 'undefined') {
            preselectMoviesCat = categories['movie_coming'];
        }
        return preselectMoviesCat;
    }
    getDistinctCategories(returnMap = false) {
        const { cards } = this.props;
        const isOnCinemaNow = this.isOnCinemaNow();
        const isComingFilms = this.isComingFilms();
        const data = cards
            .filter(card => (isOnCinemaNow && card.category === ON_CINEMA_NOW) ||
            (isComingFilms && card.category === COMING));
        let categories = {};
        if (returnMap) {
            data.forEach(card => {
                categories[card.type] = card.category;
            });
            return categories;
        }
        data.forEach(card => {
            categories[card.category] = '';
        });
        return Object.keys(categories);
    }
    isOnCinemaNow() {
        const { filmsDisplayType } = this.props;
        return filmsDisplayType ? filmsDisplayType.onCinemaNow : false;
    }
    isComingFilms() {
        const { filmsDisplayType } = this.props;
        return filmsDisplayType ? filmsDisplayType.comingFilms : false;
    }
    getUniqueCards(cards = []) {
        let uniqueCards = [];
        cards.forEach((card) => {
            const existingEvent = uniqueCards.find(e => e.link === card.link);
            if (!existingEvent) {
                uniqueCards.push(card);
            }
        });
        return uniqueCards;
    }
}
exports.Events = Events;
exports.default = Events;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-events/Events.tsx